angular.module('hj.wheelStep', []);

angular.module('hj.wheelStep').constant('Hamster', Hamster);

angular.module('hj.wheelStep').directive('hjWheelStep', ['$window', '$document', 'Hamster', function($window, $document, Hamster) {
    'use strict';
    return {
        restrict: 'A',
        link: function($scope, $element, $attr) {

            var defaults = {
                callback: function() {}
            };

            var options = angular.extend(defaults, $scope.$eval($attr.hjWheelStep));

            var deltaCount = 0;

            // http://stackoverflow.com/a/13650579/1050862
            var normaliseDelta = function(detail, wheelDelta) {
                var d = detail,
                    w = wheelDelta,
                    n = 225,
                    n1 = n - 1;

                // Normalize delta
                d = d ? w && (f = w / d) ? d / f : -d / 1.35 : w / 120;

                // Quadratic scale if |d| > 1
                d = d < 1 ? d < -1 ? (-Math.pow(d, 2) - n1) / n : d : (Math.pow(d, 2) + n1) / n;

                // Delta *should* not be greater than 2...
                return (Math.min(Math.max(d / 2, -1), 1)) * 240;
            };

            var _parents = function(node, ps) {
                if (node.parentNode === null) {
                    return ps;
                }

                return _parents(node.parentNode, ps.concat([node]));
            };

            var _scroll = function(node) {
                return (/(auto|scroll)/).test(_overflow(node));
            };

            var _overflow = function(node) {
                return _style(node, 'overflow') + _style(node, 'overflow-y') + _style(node, 'overflow-x');
            };

            var _style = function(node, prop) {
                return $window.getComputedStyle(node, null).getPropertyValue(prop);
            };

            var scrollParent = function(node) {
                if (!(node instanceof HTMLElement)) {
                    return;
                }

                var ps = _parents(node.parentNode, []);

                for (var i = 0; i < ps.length; i += 1) {
                    if (_scroll(ps[i])) {
                        return ps[i];
                    }
                }

                return $window;
            };

            var findRect = function(obj) {
                var obj2 = obj,
                    x = 0,
                    y = 0,
                    w, h;

                while ((obj && obj.offsetParent) || (obj && obj.parentNode)) {
                    var style = $window.getComputedStyle(obj);

                    if (!w || !h) {
                        w = parseInt(style.getPropertyValue('width'), 10) - parseInt(style.getPropertyValue('padding-left'), 10) - parseInt(style.getPropertyValue('padding-right'), 10);
                        h = parseInt(style.getPropertyValue('height'), 10) - parseInt(style.getPropertyValue('padding-top'), 10) - parseInt(style.getPropertyValue('padding-bottom'), 10);
                    }

                    if (style.position === 'fixed') {
                        x += parseInt(style.left, 10) + $document[0].body.scrollLeft;
                        y += parseInt(style.top, 10) + $document[0].body.scrollTop;
                    } else {
                        x += obj.offsetLeft - obj.scrollLeft;
                        y += obj.offsetTop - obj.scrollTop;
                    }

                    obj = obj.offsetParent;
                    obj2 = obj2.parentNode;

                    while (obj2 !== obj && style.position !== 'fixed') {
                        x -= !isNaN(obj2.scrollLeft) ? obj2.scrollLeft : 0;
                        y -= !isNaN(obj2.scrollTop) ? obj2.scrollTop : 0;
                        obj2 = obj2.parentNode;
                    }
                }

                return [x, y, w, h];
            };

            var scroller = scrollParent($element[0]);

            scroller = scroller === $document[0].documentElement ? $window : scroller;

            var hamster = new Hamster($element[0]).wheel(function(event, delta, deltaX, deltaY) {
                event = event.originalEvent || event;

                var scrollPos = scroller.scrollY !== undefined ? scroller.scrollY : scroller.scrollTop,
                    scrollerHeight = scroller.innerHeight !== undefined ? scroller.innerHeight : scroller.clientHeight,
                    rect = findRect($element[0]),
                    elHeight = Math.max(rect[3], $element[0].scrollHeight);

                if ((scrollPos === 0 && deltaY > 0) || (scrollPos === elHeight - scrollerHeight && deltaY < 0)) {
                    event.preventDefault();

                    var normalisedDelta = normaliseDelta(event.detail, deltaY);

                    if (deltaY !== 0) {
                        deltaCount += normalisedDelta;

                        if (Math.abs(0 - deltaCount) >= 1) {
                            deltaCount = 0;

                            options.callback(normalisedDelta);
                        }
                    }
                }
            });

        }
    };
}]);
